export default __webpack_public_path__ + "static/media/add_video_icon.9a33a3be.svg";